import {
  IContextBasedFactory,
  IDocumentServices,
  IHostType,
} from '../../index';

export type ISuperAPI = {
  accessibility: {
    getAdvancedSettings: () => Promise<boolean>;
    getSkipToContent: () => Promise<boolean>;
    getVisualFocus: () => Promise<boolean>;
    getAutoDomReorder: () => Promise<boolean>;
    setAdvancedSettings: (value: boolean) => Promise<void>;
    setSkipToContent: (
      appDefinitionId: string,
      enable: boolean,
    ) => Promise<void>;
    setVisualFocus: (appDefinitionId: string, enable: boolean) => Promise<void>;
    setAutoDomReorder: (
      appDefinitionId: string,
      enable: boolean,
    ) => Promise<void>;
  };
};

export type IHostAPI<T extends IHostType> = T extends IHostType
  ? {
      accessibility: {
        setAdvancedSettings: (value: boolean) => Promise<void>;
        // TODO: fix type
        getAdvancedSettings: () => Promise<boolean>;
      };
    }
  : never;

export function createSuperAPIFactory<T extends IHostType>(
  // NOTE: hostType is ignored in that case, however, it could be used to return a different SuperAPI per host
  // @ts-expect-error
  hostType: T,
  hostAPI: IHostAPI<T>,
  ds: IDocumentServices,
): IContextBasedFactory<ISuperAPI> {
  // NOTE: for old API we don't use context and take information from arguments
  // @ts-expect-error
  return (context) => {
    return {
      accessibility: {
        getSkipToContent: async () => ds.accessibility.skipToContent.get(),
        setSkipToContent: async (appDefinitionId, value) => {
          ds.runInContext(appDefinitionId, () =>
            ds.accessibility.skipToContent.set(value),
          );
          await ds.waitForChangesAppliedAsync();
        },
        getVisualFocus: async () => ds.accessibility.visualFocus.get(),
        setVisualFocus: async (appDefinitionId, value) => {
          ds.runInContext(appDefinitionId, () =>
            ds.accessibility.visualFocus.set(value),
          );
          await ds.waitForChangesAppliedAsync();
        },
        getAutoDomReorder: async () => ds.accessibility.autoDomReorder.get(),
        setAutoDomReorder: async (appDefinitionId, value) => {
          ds.runInContext(appDefinitionId, () =>
            ds.accessibility.autoDomReorder.set(value),
          );
          await ds.waitForChangesAppliedAsync();
        },
        getAdvancedSettings: () => {
          return hostAPI.accessibility.getAdvancedSettings();
        },
        setAdvancedSettings: (value) => {
          return hostAPI.accessibility.setAdvancedSettings(value);
        },
      },
    };
  };
}
